var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFilterRemoval = function SvgFilterRemoval(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13,22c0-5.5,4.5-10,10-10c1.3,0,2.5,0.3,3.6,0.7l1-1c0.2-0.2,0.3-0.5,0.3-0.7V6.5C28,3.4,20.7,2,14,2S0,3.4,0,6.5V11 c0,0.3,0.1,0.6,0.3,0.7L11,21.4V29c0,0.3,0.2,0.7,0.5,0.9C11.6,30,11.8,30,12,30c0.2,0,0.3,0,0.4-0.1l2.9-1.5 C13.9,26.7,13,24.5,13,22z M2,6.5C2.1,5.8,6,4,14,4c8,0,11.9,1.8,12,2.5C25.9,7.2,22,9,14,9C6,9,2.1,7.2,2,6.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3,16.3c-3.1,3.1-3.1,8.2,0,11.3s8.2,3.1,11.3,0s3.1-8.2,0-11.3S20.5,13.2,17.3,16.3z M25.8,20.6L24.4,22l1.4,1.4 c0.4,0.4,0.4,1,0,1.4c-0.4,0.4-1,0.4-1.4,0L23,23.4l-1.4,1.4c-0.4,0.4-1,0.4-1.4,0c-0.4-0.4-0.4-1,0-1.4l1.4-1.4l-1.4-1.4 c-0.4-0.4-0.4-1,0-1.4c0.4-0.4,1-0.4,1.4,0l1.4,1.4l1.4-1.4c0.4-0.4,1-0.4,1.4,0C26.2,19.6,26.2,20.2,25.8,20.6z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilterRemoval, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/filter-removal.28b01a1d.svg";
export { ForwardRef as ReactComponent };